import axios from 'axios';

export default {
  name: "set-cancel-token",
  req (payload) {
    const CancelToken = axios.CancelToken;

    payload.req.cancelToken = new CancelToken(function executor(c) {
      payload.jsonApi.cancel  = c;
    })

    return payload;
  }
};
